import {Component, Input, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import {DecimalPipe} from "@angular/common";

/**
 * Generated class for the LubbuCurrencyInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lubbu-currency-input',
  templateUrl: 'lubbu-currency-input.html'
})
export class LubbuCurrencyInputComponent {

  private _modelValue: any;

  @Input()
  get model() {
    return this._modelValue;
  }

  set model(value: any) {
    try {
      this._modelValue = Number(value).toFixed(2);
    } catch (e) {

    }
  }

  @Output() modelChange = new EventEmitter();

  @Input()
  public inputDisabled: boolean;

  @Output() onBlur = new EventEmitter();

  @Input()
  public id: string;

  @Input()
  public placeholder: string;

  constructor(private decimalPipe: DecimalPipe,
              public cdRef: ChangeDetectorRef) {
  }

  focus() {
    if (!this._modelValue || !Number(this._modelValue)) {
      let val = this.getCurrency(0);
      this._modelValue = val;
      this.modelChange.emit(val.replace(/\D+/g, ''));
      setTimeout(() => {
        this.setCaretPosition(this.id, val.length);
      }, 10);
    }
  }

  onKeyPress(evt) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(evt.charCode);
    if (!pattern.test(inputChar)) {
      return evt.preventDefault();
    }
  }

  public onPriceChanged(evt) {
    this.cdRef.detectChanges();
    let value = evt.replace(/[^0-9]/g, '');
    if (value) {
      let val = this.getCurrency(Number(value) / 100);
      this._modelValue = val;
      this.modelChange.emit(val);
      setTimeout(() => {
        this.setCaretPosition(this.id, val.length);
      }, 10);
    } else {
      this._modelValue = value;
      this.modelChange.emit(value);
      this.focus();
    }
  }

  emitBlur() {
    this.onBlur.emit(true);
  }

  getCurrency(amount: number) {
    let val = amount.toString();
    return this.decimalPipe.transform(val, '1.2-2');
  }

  private setCaretPosition(elemId, caretPos) {
    let el: any = document.getElementById(elemId);
    if (el !== null) {
      if (el.createTextRange) {
        let range = el.createTextRange();
        range.move('character', caretPos);
        range.select();
        return true;
      }
      else {
        if (el.selectionStart || el.selectionStart === 0) {
          el.focus();
          el.setSelectionRange(caretPos, caretPos);
          return true;
        }
        else {
          el.focus();
          return false;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/lubbu-currency-input/lubbu-currency-input.ts